// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"section-header_sectionHeader__3C_zD"};